import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    userId = '',
    username = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.admin.nameExists, {
        userId,
        username,
    }, options);
    if (error) return { error, status };
    return content || {};
};
